import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  apiUrl = environment.apiUrl
  
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
  
    constructor(private http: HttpClient,private _authservice:AuthService) { }
  
    getDashboardContent():Observable<any>
    {
      const token = this._authservice.getAuthToken();
      const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });   
      return this.http.get<any[]>(this.apiUrl+'dashboard/getDashboardContent',{headers:headers})
    }

    getCoachedParticipantCountForCoachAndAdmin(startDate: Date, endDate: Date): Observable<number>
    {
      const token = this._authservice.getAuthToken();
      const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
      let params = new HttpParams();
      params = params.append('StartDate', startDate.toISOString());
      params = params.append('EndDate', endDate.toISOString());
      return this.http.get<number>(this.apiUrl+'dashboard/getCoachedParticipantCountForCoachAndAdmin',{headers:headers,params:params})
    }
  
}
